module.exports = __webpack_public_path__ + "static/media/mbDipstickAssemblyEnduranceTestingRig.30ec39ad.jpg";